import axios from "@/api/axiosInstance";
import { FetchStagesWithPermissionsResponse } from "./types";

export const fetchStagesWithPermissions =
  async (): Promise<FetchStagesWithPermissionsResponse> => {
    const response = await axios.get<FetchStagesWithPermissionsResponse>(
      "/api/private/admin/stages/permissions",
    );
    return response.data;
  };
